/** Orchestrates and prepares the properties required for keyboard-driven task list navigation. */
import { useNavigate, useLocation } from 'react-router-dom';
import { buildKeyboardNavPropsObject } from '@/features/tasks/utils/interactions/buildKeyboardNavProps';

/**
 * Assembles the props object for useTaskListKeyboardNavigation.
 * Returns null when there are no tasks so the caller can pass a safe fallback.
 */
export function useKeyboardNavProps(args) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!args.tasks || args.tasks.length === 0) return null;

  return buildKeyboardNavPropsObject({
    ...args,
    navigate,
    pathname,
  });
}
